import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchTrackFraudPeriode, fetchTrackSpeed, fetchTrackFraudPeriodeToday } from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushShipFraud } from "actions/portal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import CatSpeed from "./catspeed";
import IconSettings from "@material-ui/icons/Settings";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import Button from "components/CustomButtons/Button.jsx";
import { NavLink, withRouter } from "react-router-dom";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InactiveCat from "./inactivecat";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardBody from "components/Card/CardBody.jsx";
import FormControl from "@material-ui/core/FormControl";
import { fetchTrackFraud, fetchApproachTotal } from "../../api/portal";
import { pushLoader } from "../../actions/main";
import moment from "moment";
import ReactExport from "assets/libs/react-export-excel";
import Warning from "@material-ui/icons/Warning";
import Info from "@material-ui/icons/CheckCircle";
import NavPills from "../../components/NavPills/NavPills.jsx";
import { TextField } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Speed Alert ${moment().format("LLL")}`;

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5
  }
});

let delay = null;

class Fraud extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      datatableHistorikal: [],
      selectedCategory: "",
      selectedCategoryPeriode: "30",
      catspeed: [],
      loader: null,
      startDate: moment()
        .subtract(30, "minutes")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
      totalData: 100,
      loader2: null,
      searchCheck: false,
      sort: [
        "none",
        "none",
        "none",
        "none",
        "desc",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ],
      orderby: `"total_fraud"`,
      activeColumn: 4,
      displayStatus: [
        false,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        true,
        true,
        true,
        true
      ]
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader2: true });
    fetchTrackFraudPeriodeToday()
      .then(response => {
        const dat = response.data.results;
        //this.setState({ catspeed: dat, selectedCategory: dat[0].id });

        let datatablebaru = [];

        // tambah urutan
        response.data.results.map(e => {
          let urutan = 0;

          // cek status GPS
          let delayinminutes_gps = moment.duration(
            moment(e.dateCreated).diff(moment(e.last_gps))
          );
          let delaynya_gps = delayinminutes_gps.asHours();

          if (delaynya_gps > 2) {
            urutan++;
          }
          // end cek status GPS

          // cek status AIS
          let delayinminutes_ais = moment.duration(
            moment(e.dateCreated).diff(moment(e.last_ais))
          );
          let delaynya_ais = delayinminutes_ais.asHours();

          if (delaynya_ais > 2) {
            urutan++;
          }
          // end cek status AIS

          // cek status CCTV
          let cctvDate = moment(
            `${e.last_cctv}`,
            "YYYY-MM-DD h:mm:ss"
          ).toDate();
          let delayinminutes_cctv = moment.duration(
            moment(e.dateCreated).diff(moment(cctvDate))
          );

          let delaynya_cctv = delayinminutes_cctv.asHours();

          if (delaynya_cctv > 2 || e.last_cctv === "undefined") {
            urutan++;
          }

          // if (e.approachexist !== null) {
          //   urutan++
          // }

          if (e.approachexist !== 0) {
            e.total_fraud = eval(e.total_fraud) + 1;
          }

          // end cek status CCTV

          datatablebaru.push({
            catspeedalert: e.catspeedalert,
            catspeedalert_id: e.catspeedalert_id,
            dateCreated: e.dateCreated,
            first_recorded: e.first_recorded,
            fraud_id: e.fraud_id,
            id: e.id,
            idle_time: e.idle_time,
            last_ais: e.last_ais,
            last_cctv: cctvDate,
            last_gps: e.last_gps,
            latitude: e.latitude,
            longitude: e.longitude,
            name: e.name,
            shipid: e.shipid,
            shiptype: e.shiptype,
            speed: e.speed,
            weather: e.weather,
            wind_speed: e.wind_speed,
            total_fraud: e.total_fraud,
            approachexist: e.approachexist
          });
        });

        this.setState({
          datatableHistorikal: datatablebaru,
          totalData: response.data.total
        });

        //end tambah urutan
        this.props.pushLoader(false);
        this.setState({ loader2: false });
      })
      .catch(error => {
        this.props.pushLoader(false);
        this.setState({ loader2: false });
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  }

  componentDidMount() {
    if (this.props.shipFraud != []) {
      this.props.pushShipFraud([0, 0]);
    }
  }

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handlecat = e => {
    this.setState({ selectedCategory: e.target.value });

    fetchTrackSpeed(e.target.value, this.state.selectedCategoryPeriode)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handlecatperiode = e => {
    this.setState({ selectedCategoryPeriode: e.target.value });
    fetchTrackSpeed(this.state.selectedCategory, e.target.value)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleKeyword = async e => {
    await this.setState({ keyword: e });
    await this.handleSearch(10, 0);
  };

  handleSearch = (rows, page) => {
    this.setState({ loader2: true, datatableHistorikal: [] });
    fetchTrackFraudPeriode(
      this.state.startDate.replace("T", " "),
      this.state.endDate.replace("T", " "),
      rows,
      rows * page,
      this.state.orderby,
      this.state.sort[this.state.activeColumn],
      this.state.keyword ? this.state.keyword.toUpperCase() : ""
    )
      .then(response => {
        const dat = response.data.results;
        //this.setState({ catspeed: dat, selectedCategory: dat[0].id });

        let datatablebaru = [];

        // tambah urutan
        response.data.results.map(e => {
          let urutan = 0;

          // cek status GPS
          let delayinminutes_gps = moment.duration(
            moment(e.dateCreated).diff(moment(e.last_gps))
          );
          let delaynya_gps = delayinminutes_gps.asHours();

          if (delaynya_gps > 2) {
            urutan++;
          }
          // end cek status GPS

          // cek status AIS
          let delayinminutes_ais = moment.duration(
            moment(e.dateCreated).diff(moment(e.last_ais))
          );
          let delaynya_ais = delayinminutes_ais.asHours();

          if (delaynya_ais > 2) {
            urutan++;
          }
          // end cek status AIS

          // cek status CCTV
          let cctvDate = moment(
            `${e.last_cctv}`,
            "YYYY-MM-DD h:mm:ss"
          ).toDate();
          let delayinminutes_cctv = moment.duration(
            moment(e.dateCreated).diff(moment(cctvDate))
          );

          let delaynya_cctv = delayinminutes_cctv.asHours();

          if (delaynya_cctv > 2 || e.last_cctv === "undefined") {
            urutan++;
          }

          // if (e.approachexist !== null) {
          //   urutan++
          // }

          if (e.approachexist !== 0) {
            e.total_fraud = eval(e.total_fraud) + 1;
          }

          // end cek status CCTV

          datatablebaru.push({
            catspeedalert: e.catspeedalert,
            catspeedalert_id: e.catspeedalert_id,
            dateCreated: e.dateCreated,
            first_recorded: e.first_recorded,
            fraud_id: e.fraud_id,
            id: e.id,
            idle_time: e.idle_time,
            last_ais: e.last_ais,
            last_cctv: cctvDate,
            last_gps: e.last_gps,
            latitude: e.latitude,
            longitude: e.longitude,
            name: e.name,
            shipid: e.shipid,
            shiptype: e.shiptype,
            speed: e.speed,
            weather: e.weather,
            wind_speed: e.wind_speed,
            total_fraud: e.total_fraud,
            approachexist: e.approachexist
          });
        });

        this.setState({
          datatableHistorikal: datatablebaru,
          totalData: response.data.total
        });

        //end tambah urutan

        this.props.pushLoader(false);
        this.setState({ loader2: false });
      })
      .catch(error => {
        this.props.pushLoader(false);
        this.setState({ loader2: false });
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleSearchClick = async () => {
    await this.setState({
      searchCheck: true,
      sort: [
        "none",
        "none",
        "none",
        "none",
        "desc",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ],
      orderby: `"total_fraud"`,
      activeColumn: 4
    });
    this.handleSearch(10, 0);
  };

  renderOptcat = e => {
    return <MenuItem value={e.id}> {e.name} </MenuItem>;
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "shipid",
        label: "Ship Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "name",
        label: "Ship Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "fraud_id",
        label: "Fraud Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dateCreated",
        label: "Checking Time",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          }
        }
      },
      {
        name: "idle_time",
        label: "Idle Time (hours)",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let valnya = parseFloat(value).toFixed(2);
            return valnya;
          }
        }
      },

      {
        name: "last_gps",
        label: "GPS",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let a = moment(tableMeta.rowData[3]).format("YYYY-MM-DD HH:mm:ss");

            let b = moment(value).format("YYYY-MM-DD HH:mm:ss");

            let delayinminutes = moment.duration(
              moment(tableMeta.rowData[3]).diff(moment(value))
            );

            let delaynya = delayinminutes.asHours();

            if (delaynya > 2) {
              return (
                <span>
                  <Warning color="secondary" />
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          }
        }
      },

      {
        name: "last_ais",
        label: "AIS",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let a = moment(tableMeta.rowData[4]).format("YYYY-MM-DD HH:mm:ss");

            let b = moment(value).format("YYYY-MM-DD HH:mm:ss");

            let delayinminutes = moment.duration(
              moment(tableMeta.rowData[4]).diff(moment(value))
            );

            let delaynya = delayinminutes.asHours();

            if (delaynya > 2) {
              return (
                <span>
                  <Warning color="secondary" />
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          }
        }
      },
      {
        name: "last_cctv",
        label: "CCTV",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let a = moment(tableMeta.rowData[4]).format("YYYY-MM-DD HH:mm:ss");

            let b = moment(value).format("YYYY-MM-DD HH:mm:ss");

            let delayinminutes = moment.duration(
              moment(tableMeta.rowData[4]).diff(moment(value))
            );

            let delaynya = delayinminutes.asHours();

            if (delaynya > 2 || value === "undefined") {
              return (
                <span>
                  <Warning color="secondary" />{" "}
                </span>
              );
            } else if (isNaN(delaynya) == true) {
              return (
                <span>
                  <Warning color="secondary" />{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          }
        }
      },
      {
        name: "approachexist",
        label: "Approach Status",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return (
                <span>
                  <Warning color="secondary" />{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          }
        }
      },
      {
        name: "last_gps",
        label: "Last GPS",
        options: {
          filter: false,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          }
        }
      },
      {
        name: "last_ais",
        label: "Last AIS",
        options: {
          filter: false,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          }
        }
      },
      {
        name: "last_cctv",
        label: "Last CCTV",
        options: {
          filter: false,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          }
        }
      },

      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "catspeedalert",
        label: "Speed Category",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "catspeedalert_id",
        label: "Catspeedalert Id",
        options: {
          filter: false,
          display: false
        }
      },

      {
        name: "total_fraud",
        label: "Total Warning",
        options: {
          filter: true,
          display: true,
          sort: true,
          options: { sortDirection: "desc" }
        }
      },
      {
        name: "speed",
        label: "Speed (knots)",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let val = value * 0.1;
            return val.toFixed(2);
          }
        }
      },
      {
        name: "weather",
        label: "Weather",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "wind_speed",
        label: "Wind Speed",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "first_recorded",
        label: "First Recorded",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          }
        }
      },

      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() =>
                    this.props.pushShipFraud([
                      tableMeta.rowData[13],
                      tableMeta.rowData[14],
                      tableMeta.rowData[0],
                      tableMeta.rowData[1],
                      tableMeta.rowData[3],
                      tableMeta.rowData[4],
                      tableMeta.rowData[5],
                      tableMeta.rowData[10],
                      tableMeta.rowData[11],
                      tableMeta.rowData[12],
                      tableMeta.rowData[17],
                      tableMeta.rowData[18],
                      tableMeta.rowData[19],
                      tableMeta.rowData[20]
                    ])
                  }
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const columns2 = [
      {
        name: "shipid",
        label: "Ship Id",
        options: {
          filter: false,
          display: this.state.displayStatus[0],
          sortDirection: this.state.sort[0]
        }
      },
      {
        name: "name",
        label: "Ship Name",
        options: {
          filter: false,
          display: this.state.displayStatus[1],
          sortDirection: this.state.sort[1]
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: this.state.displayStatus[2],
          sortDirection: this.state.sort[2]
        }
      },
      {
        name: "fraud_id",
        label: "Fraud Id",
        options: {
          filter: false,
          display: this.state.displayStatus[3],
          sortDirection: this.state.sort[3]
        }
      },
      {
        name: "dateCreated",
        label: "Checking Time",
        options: {
          filter: false,
          display: this.state.displayStatus[4],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[4]
        }
      },
      {
        name: "idle_time",
        label: "Idle Time (hours)",
        options: {
          filter: false,
          display: this.state.displayStatus[5],
          customBodyRender: (value, tableMeta, updateValue) => {
            let valnya = parseFloat(value).toFixed(2);
            return valnya;
          },
          sortDirection: this.state.sort[5]
        }
      },

      {
        name: "last_gps",
        label: "GPS",
        options: {
          filter: false,
          display: this.state.displayStatus[6],
          customBodyRender: (value, tableMeta, updateValue) => {
            let a = moment(tableMeta.rowData[3]).format("YYYY-MM-DD HH:mm:ss");

            let b = moment(value).format("YYYY-MM-DD HH:mm:ss");

            let delayinminutes = moment.duration(
              moment(tableMeta.rowData[3]).diff(moment(value))
            );

            let delaynya = delayinminutes.asHours();

            if (delaynya > 2) {
              return (
                <span>
                  <Warning color="secondary" />
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          },
          sortDirection: this.state.sort[6]
        }
      },

      {
        name: "last_ais",
        label: "AIS",
        options: {
          filter: false,
          display: this.state.displayStatus[7],
          customBodyRender: (value, tableMeta, updateValue) => {
            let a = moment(tableMeta.rowData[4]).format("YYYY-MM-DD HH:mm:ss");

            let b = moment(value).format("YYYY-MM-DD HH:mm:ss");

            let delayinminutes = moment.duration(
              moment(tableMeta.rowData[4]).diff(moment(value))
            );

            let delaynya = delayinminutes.asHours();

            if (delaynya > 2) {
              return (
                <span>
                  <Warning color="secondary" />
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          },
          sortDirection: this.state.sort[7]
        }
      },
      {
        name: "last_cctv",
        label: "CCTV",
        options: {
          filter: false,
          display: this.state.displayStatus[8],
          customBodyRender: (value, tableMeta, updateValue) => {
            let a = moment(tableMeta.rowData[4]).format("YYYY-MM-DD HH:mm:ss");

            let b = moment(value).format("YYYY-MM-DD HH:mm:ss");

            let delayinminutes = moment.duration(
              moment(tableMeta.rowData[4]).diff(moment(value))
            );

            let delaynya = delayinminutes.asHours();

            if (delaynya > 2 || value === "undefined") {
              return (
                <span>
                  <Warning color="secondary" />{" "}
                </span>
              );
            } else if (isNaN(delaynya) == true) {
              return (
                <span>
                  <Warning color="secondary" />{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          },
          sortDirection: this.state.sort[8]
        }
      },
      {
        name: "approachexist",
        label: "Approach Status",
        options: {
          filter: false,
          display: this.state.displayStatus[9],
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return (
                <span>
                  <Warning color="secondary" />{" "}
                </span>
              );
            } else {
              return (
                <span>
                  <Info color="primary" />
                </span>
              );
            }
          },
          sortDirection: this.state.sort[9]
        }
      },
      {
        name: "last_gps",
        label: "Last GPS",
        options: {
          filter: false,
          display: this.state.displayStatus[10],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[10]
        }
      },
      {
        name: "last_ais",
        label: "Last AIS",
        options: {
          filter: false,
          display: this.state.displayStatus[11],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[11]
        }
      },
      {
        name: "last_cctv",
        label: "Last CCTV",
        options: {
          filter: false,
          display: this.state.displayStatus[12],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[12]
        }
      },

      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: this.state.displayStatus[13],
          sortDirection: this.state.sort[13]
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: this.state.displayStatus[14],
          sortDirection: this.state.sort[14]
        }
      },
      {
        name: "catspeedalert",
        label: "Speed Category",
        options: {
          filter: false,
          display: this.state.displayStatus[15],
          sortDirection: this.state.sort[15]
        }
      },
      {
        name: "catspeedalert_id",
        label: "Catspeedalert Id",
        options: {
          filter: false,
          display: this.state.displayStatus[16],
          sortDirection: this.state.sort[16]
        }
      },
      {
        name: "total_fraud",
        label: "Total Warning",
        options: {
          filter: true,
          display: true,
          sort: true
          // options: { sortDirection: 'desc' }
        }
      },
      {
        name: "speed",
        label: "Speed (knots)",
        options: {
          filter: false,
          display: this.state.displayStatus[18],
          customBodyRender: (value, tableMeta, updateValue) => {
            let val = value * 0.1;
            return val.toFixed(2);
          },
          sortDirection: this.state.sort[18]
        }
      },
      {
        name: "weather",
        label: "Weather",
        options: {
          filter: false,
          display: this.state.displayStatus[19],
          sortDirection: this.state.sort[19]
        }
      },
      {
        name: "wind_speed",
        label: "Wind Speed",
        options: {
          filter: false,
          display: this.state.displayStatus[20],
          sortDirection: this.state.sort[20]
        }
      },
      {
        name: "first_recorded",
        label: "First Recorded",
        options: {
          filter: false,
          display: this.state.displayStatus[21],
          customBodyRender: (value, tableMeta, updateValue) => {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
          },
          sortDirection: this.state.sort[21]
        }
      },

      {
        name: "Action",
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() =>
                    this.props.pushShipFraud([
                      tableMeta.rowData[13],
                      tableMeta.rowData[14],
                      tableMeta.rowData[0],
                      tableMeta.rowData[1],
                      tableMeta.rowData[3],
                      tableMeta.rowData[4],
                      tableMeta.rowData[5],
                      tableMeta.rowData[10],
                      tableMeta.rowData[11],
                      tableMeta.rowData[12],
                      tableMeta.rowData[17],
                      tableMeta.rowData[18],
                      tableMeta.rowData[19],
                      tableMeta.rowData[20]
                    ])
                  }
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: "none",
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,

      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    const options2 = {
      filter: false,
      search: true,
      selectableRows: "none",
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader2
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      },
      onTableChange: async (action, tableState) => {
        switch (action) {
          case "changePage":
            this.handleSearch(tableState.rowsPerPage, tableState.page);
            break;
          case "changeRowsPerPage":
            this.handleSearch(tableState.rowsPerPage, tableState.page);
            break;
          case "propsUpdate":
            if (this.state.searchCheck) {
              this.setState({ searchCheck: false });
              tableState.page = 0;
              tableState.rowsPerPage = 10;
            }
            break;
          case "sort":
            tableState.page = 0;
            const condition = tableState.announceText.split(" ");
            const listColumn = this.state.sort;
            listColumn.forEach((value, index) => {
              let ascdesc;
              if (index === tableState.activeColumn) {
                if (condition[6] === "ascending") {
                  ascdesc = "asc";
                } else {
                  ascdesc = "desc";
                }
                this.state.sort[tableState.activeColumn] = ascdesc;
              } else {
                this.state.sort[index] = "none";
              }
            });
            await this.setState({
              orderby:
                tableState.columns[tableState.activeColumn].name ===
                "dateCreated"
                  ? `"dateCreated"`
                  : tableState.columns[tableState.activeColumn].name,
              activeColumn: tableState.activeColumn
            });
            this.handleSearch(
              tableState.rowsPerPage,
              tableState.page,
              this.state.activeColumn,
              this.state.orderby
            );
            break;
          case "search":
            if (delay !== null) {
              clearTimeout(delay);
            }
            delay = setTimeout(async () => {
              let searchKeyword = tableState.searchText
                ? tableState.searchText
                : "";
              await this.handleKeyword(searchKeyword);
              tableState.searchText = this.state.keyword;
            }, 3000);
          case "columnViewChange":
            tableState.columns.forEach((column, index) => {
              if (column.display !== this.state.displayStatus[index]) {
                this.state.displayStatus[index] = column.display;
              }
            });
          default:
            break;
        }
      },
      serverSide: true,
      count: this.state.totalData,
      searchText: this.state.keyword
    };

    return (
      <div>
        <Grid item xs={12}>
          <div className={classes.content}>
            <Grid item xs={12}>
              <Grid container spacing={5}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="Start Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.startDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.startDate,
                      onChange: this.handleStartDate
                    }}
                  />
                  <TextField
                    size="small"
                    id="datetime-local"
                    label="End Date"
                    type="datetime-local"
                    className={classes.textField}
                    defaultValue={this.state.endDate}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      value: this.state.endDate,
                      onChange: this.handleEndDate
                    }}
                  />
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={this.state.loader2}
                    onClick={() => this.handleSearchClick()}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
              <MUIDataTable
                data={this.state.datatableHistorikal}
                columns={columns2}
                options={options2}
              />
            </Grid>
            {/*<Grid item xs={12}>
              <Card>
                <CardContent>

                  <ExcelFile
                    element={
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={this.state.loader}
                      >
                        Download as .xslx
                      </Button>
                    }
                    filename={`${fileName}`}
                    fileExtension="xslx"
                  >
                    <ExcelSheet data={this.state.datatable} name="Sheet 1">
                      <ExcelColumn label="Ship ID" value="shipid" />
                      <ExcelColumn label="Ship Name" value="name" />
                      <ExcelColumn label="dateCreated" value="dateCreated" />
                      <ExcelColumn label="Latitude" value="latitude" />
                      <ExcelColumn label="Longitude" value="longitude" />
                      <ExcelColumn
                        label="Speed Category"
                        value="catspeedalert"
                      />
                      <ExcelColumn
                        label="Speed returned in (knots x10)"
                        value="speed"
                      />
                    </ExcelSheet>
                  </ExcelFile>
                </CardContent>
              </Card>
            </Grid>*/}
            {/* <NavPills
              color="blue"
              alignCenter={true}
              tabs={[
                {
                  tabButton: "Actual",
                  tabContent: (
                    <Grid item xs={12}>
                      <MUIDataTable
                        data={this.state.datatable}
                        columns={columns}
                        options={options}
                      />
                      <Dialog
                        maxWidth={"md"}
                        open={this.state.openAdd}
                        onClose={() => this.handleClose("openAdd", false)}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Manage Category
                        </DialogTitle>
                        <DialogContent>
                          <CatSpeed />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => this.handleClose("openAdd", false)}
                            color="danger"
                            round
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                  )
                },
                {
                  tabButton: "Histories",
                  tabContent: (
                    <Grid item xs={12}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            size="small"
                            id="datetime-local"
                            label="Start Date"
                            type="datetime-local"
                            className={classes.textField}
                            defaultValue={this.state.startDate}
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{
                              value: this.state.startDate,
                              onChange: this.handleStartDate
                            }}
                          />
                          <TextField
                            size="small"
                            id="datetime-local"
                            label="End Date"
                            type="datetime-local"
                            className={classes.textField}
                            defaultValue={this.state.endDate}
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{
                              value: this.state.endDate,
                              onChange: this.handleEndDate
                            }}
                          />
                          <Button
                            color="primary"
                            variant="contained"
                            disabled={this.state.loader2}
                            onClick={() => this.handleSearchClick()}
                          >
                            Search
                          </Button>
                        </Grid>
                      </Grid>
                      <MUIDataTable
                        data={this.state.datatableHistorikal}
                        columns={columns2}
                        options={options2}
                      />
                      <Dialog
                        maxWidth={"md"}
                        open={this.state.openAdd}
                        onClose={() => this.handleClose("openAdd", false)}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Manage Category
                        </DialogTitle>
                        <DialogContent>
                          <CatSpeed />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => this.handleClose("openAdd", false)}
                            color="danger"
                            round
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                  )
                }
              ]}
            /> */}
          </div>
        </Grid>
      </div>
    );
  }
}

Fraud.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushShipFraud: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushShipFraud, pushLoader }
)(withStyles(styles)(Fraud)));
